const accordion = () => {
  $('.js-accordion').accordion();
};
